import React from 'react';
import { Formik, Form, Field } from 'formik';
import Modal from '../../Atoms/Modal/Modal';
import Buttons from '../../Atoms/Buttons/Buttons';
import folderIcon from '../../../assets/Imagess/folderICon.svg';
import gradIcon from '../../../assets/Imagess/grad-hat.svg';
// import { toast } from "react-toastify";
import styles from './AddCourseModal.module.scss';
import 'react-datepicker/dist/react-datepicker.css';
import CustomInput from '../../Atoms/forms/input/CustomInput';
import { isEmpty, values } from 'lodash';
import CustomSelect from '../../Atoms/forms/customSelect/CustomSelect';
import * as Yup from 'yup';
import TextInput from '../../Atoms/Inputs/TextInput';
import CustomizedSelect from '../../Atoms/Inputs/CustomizedSelect';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../Constants';
import { useParams } from 'react-router-dom';
import { useToast } from '../Custom/CustomToaster/Toast';

const AddCourseModal = ({
  handleOnClose,
  title,
  selectedItem,
  setSelectedItem,
  mode,
  refetchProgram,
  detailsToShow,
  selectedYear,
}) => {
  const { id } = useParams();
  const toast = useToast();
  const semesterOptions = [
    {
      value: 0,
      text: 'Semester 1',
    },
    {
      value: 1,
      text: 'Semester 2',
    },
  ];

  const initialValues = {
    // SemesterId: 0,
    CourseAR: selectedItem?.courseAR || '',
    CourseCredits: selectedItem?.courseCredits,
  };

  const validationSchema = Yup.object().shape({
    // SemesterId: Yup.number().required("SemesterId is required"),
    CourseAR: Yup.string().required('CourseAR is required'),
    CourseCredits: Yup.number().required('CourseAR is required'),
  });

  const handleSubmit = useMutation({
    mutationFn: (fields) => {
      return axios.post(
        API_URL + `/api/Degree/CurriculumDetails`,
        fields,

        {
          headers: securityHeaders,
        }
      );
    },
    onSuccess: (data) => {
      setSelectedItem({});
      handleOnClose();
      toast.open(
        mode === 'Add' ? 'تمت إضافة الوحدة بنجاح' : 'تم تحديث الوحدة بنجاح'
      );
      refetchProgram();
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const formData = new FormData();
        formData.append('DegreeId', id);
        formData.append(
          'CurDetailId',
          selectedItem?.curDetailId || '00000000-0000-0000-0000-000000000000'
        );
        formData.append('Year', selectedYear);
        // formData.append("SemesterId", values.SemesterId);
        formData.append('CourseEN', values.CourseEN);
        formData.append('CourseAR', values.CourseAR);
        formData.append(
          'CourseTypeId',
          selectedItem?.courseTypeId || '00000000-0000-0000-0000-000000000000'
        );
        formData.append('CourseCredits', values.CourseCredits);
        handleSubmit.mutate(formData);
      }}
    >
      {({ errors, touched, values, setFieldValue, handleSubmit }) => {
        return (
          <Form>
            <Modal
              onClose={handleOnClose}
              title={mode == 'Add' ? 'Add' + ' ' + title : 'Edit' + ' ' + title}
              width="35rem"
              closeWhite={false}
            >
              <TextInput
                label="اسم الدورة"
                placeholder="أدخل الدورة"
                icon={folderIcon}
                style={{
                  width: '100%',
                  justifyContent: 'flex-start',
                  marginTop: '25px',
                  direction: 'rtl',
                }}
                inputStyleProp={{ height: '62px', marginTop: '4px' }}
                name="CourseAR"
                value={values.CourseAR}
                onChange={(name, value) => {
                  setFieldValue(name, value);
                }}
                errors={errors.CourseAR}
                touched={touched.CourseAR}
                left
              />
              <TextInput
                label="Module Credit"
                placeholder="Enter Module Credit"
                icon={folderIcon}
                style={{
                  width: '100%',
                  justifyContent: 'flex-start',
                  marginTop: '25px',
                  direction: 'rtl',
                }}
                inputStyleProp={{ height: '62px', marginTop: '4px' }}
                name="CourseCredits"
                value={values.CourseCredits}
                onChange={(name, value) => {
                  setFieldValue(name, value);
                }}
                errors={errors.CourseCredits}
                touched={touched.CourseCredits}
              />

              <Buttons
                text={mode === 'Add' ? 'حفظ' : 'تحديث'}
                handleOnClick={handleSubmit}
                rounded={true}
                style={{
                  marginTop: '25px',
                  padding: '16px 19px',
                  borderRadius: '50px',
                  fontFamily: 'BukraBold',
                  fontSize: '20px',
                }}
              />
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddCourseModal;
